export const strings = {
    "message.welcome": "Bem vinda"
}